import { MemberInterface } from '@interface/member/member.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialMembersState: BaseStoreInterface<Record<string, MemberInterface>> = {
  ...BaseStoreStructure,
  data: {},
  meta: {},
};
